// import { useFormContext } from "react-hook-form";
import React, { useState, useEffect } from "react";
import { validateInput } from "../../utilities/Validator";
const TextFieldRegional = ({
  type = "text",
  inputClass,
  id,
  label,
  placeholder,
  value,
  name,
  getError,
  disabled,
  iconclass,
  validators,
  required,
  onChange,
  lang,
  refValue,
  labelClass,
  labelStyle,
}) => {
  const [error, setError] = useState(false); 
  const [success, setSuccess] = useState(false);
  const handleKeyPress = (event) => {
    event.preventDefault();
    event.stopPropagation();
  }
  const handleChange = (event) => {
    const { value } = event.target;
    if (validateInput(validators, value))
      setError(validateInput(validators, value));
    else if (
      type === "email" &&
      !validateInput(validators, value) &&
      value !== ""
    ) {
      setSuccess(true);
      setError(false);
    } else {
      setError(false);
    }
    onChange(value);
    getError &&
      getError(
        validateInput(validators, value)
          ? validateInput(validators, value)
          : false
      );
  };

  return (
    <>
    {label && (
      <div className={labelClass}>
        <label className="input-label" style={labelStyle}>
          {label}
          {required ? <b className={"text-danger"}> *</b> : ""}
        </label>
      </div>
    )}
    <div className={inputClass}>
      <div className="form-group">
        <input
          style={{ height: "40px" }}
          type="text"
          id={id}
          ref={refValue}
          value={value}
          name={name}
          disabled={disabled ? disabled : ""}
          className="form-control"
          iconclass="iconclass"
          onChange={handleChange}
          placeholder={placeholder}
          onKeyPress={handleKeyPress}
        />

        {iconclass && <i className={iconclass}></i>}

        {
          <i
            className="fa fa-keyboard-o"
            aria-hidden="true"
            onClick={() => {
              window.openKeyboard(lang);
            }}
          ></i>
        }
        {(error || Error && Error[name]) && <span className="text-danger errormsg">{error.message|| Error[name]}</span>}
      </div>
    </div>
    </>
  );
};

export default TextFieldRegional;
